<template>
    <div class="container-sales">
        <div class="modal-shade" @click="isSortShow=false" v-if="isSortShow" />
        <div class="term">
            <span class="default" @click="changeTimeRange(2)" :class="{'date-chose': countType == 2}">近一个月</span>
            <span class="default" @click="changeTimeRange(3)" :class="{'date-chose': countType == 3}">近三个月</span>
            <div class="sep"></div>
            <div class="sort" @click="isSortShow=true">
                {{ sortText[sortField] }}
                <img class="select" src="../../../assets/select.png">
            </div>
            <transition @after-leave="afterAnimationDone">
                <div class="condition-select" v-show="isSortShow">
                    <div>
                        <div class="option" v-for="(iterm, key) in sortText" :key="key" @click="changeSort(key)">
                            <div class="option-text" :class="{'selected':sortField== key}">{{ iterm }}</div>
                            <img v-if="sortField== key" class="option-select" src="../../../assets/selected.png">
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div class="list">
            <div class="iterm" v-for="(iterm, key) in list" :key="key" @click="$router.push(`/department/detail/${iterm.departmentId}.html`)">
                <div class="title">
                    <div class="num" :class="{'first':key==0,'second':key==1,'third':key==2}">{{ key+1 }}</div>
                    <div class="company">{{ iterm.salesDepartmentName }}</div>
                </div>
                <div class="data-group">
                    <div class="chunk">
                        <div class="desc">上榜次数</div>
                        <div class="number">{{ iterm.rankCount }}</div>
                    </div>
                    <div class="chunk">
                        <div class="desc">买入次数</div>
                        <div class="number">{{ iterm.buyCount }}</div>
                    </div>
                    <div class="chunk">
                        <div class="desc">买入额</div>
                        <div class="text">{{ formatUnit(iterm.totalBuySum) }}</div>
                    </div>
                    <div class="chunk">
                        <div class="desc">卖出额</div>
                        <div class="text green-text">-{{ formatUnit(iterm.totalSaleSum) }}</div>
                    </div>
                </div>
            </div>
            <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" direction="bottom" :distance="100">
                <div slot="spinner" class="tab-spinner">正在加载...</div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
import {request} from '@/api/request';
import InfiniteLoading from 'vue-infinite-loading';
import {formatUnit} from '@/utils/formatUnit';

export default {
    components: {
        InfiniteLoading
    },
    data() {
        return {
            isSortShow: false,
            countType: 2, // 2:近一个月 3:近三个月
            sortField: 'rankCount',
            page: 0,
            list: [],
            infiniteId: +new Date(),
            sortText: {
                rankCount: '上榜次数从高到低',
                totalBuySum: '买入额从高到低',
                totalSaleSum: '卖出额从高到低'
            },
        }
    },
    methods: {
        afterAnimationDone(el) {
            // 动画执行完后重新请求列表
            this.$emit('animationDone');
        },
        changeSort(type) {
            this.isSortShow = false;
            if (this.sortField == type) return;
            this.$on('animationDone', () => {
                this.sortField = type;
                this.list = [];
                this.page = 0
                this.infiniteId += 1;
            });
        },
        changeTimeRange(countType) {
            if(countType == this.countType) return;
            this.countType = countType;
            this.list = [];
            this.page = 0
            this.infiniteId += 1;
        },
        formatUnit(val) {
            if(!val) return 0;
            return formatUnit(val);
        },
        async getDepartmentList() {
            const res = await request.get({
                url: request.apis.rank.salesList,
                params: {
                    countType: this.countType,
                    sortField: this.sortField,
                    sortType: 'desc',
                    page: this.page + 1,
                    pageSize: 30
                }
            });
            if(res.list && res.list.length) {
                this.page += 1;
                return res.list;
            }
            return []; 
        },
        async infiniteHandler($state) {
            const list = await this.getDepartmentList(this.page);
            if (list.length) {
                this.list = this.list.concat(list);
                $state.loaded();
            } else {
                $state.complete();
            }
        }
    }
}
</script>

<style lang="stylus" src="./sales.styl" scoped></style>